import uuid from 'uuid/v4';
import * as I18n from 'circe/I18n';

const buildTruckObject = (
  _id,
  name,
  lenght,
  width,
  height,
  dimsUnit,
  weight,
  weightUnit,
  numberOfPallets,
  icon = 'TelevisionIcon',
) => ({
  _id,
  index: 0,
  name,
  dimensions: {
    lenght,
    width,
    height,
    unit: dimsUnit,
  },
  weight: {
    value: weight,
    unit: weightUnit,
  },
  stackable: false,
  icon,
  pallets: numberOfPallets,
});

const pickup = buildTruckObject(
  `${uuid()}-pickup`,
  I18n.str('pickupTruck', 'Pickup'),
  5.6,
  5.6,
  5.6,
  'CM',
  2975,
  'KG',
  1,
);
const van = buildTruckObject(
  `${uuid()}-van`,
  I18n.str('vanTruck', 'Van'),
  5.6,
  5.6,
  5.6,
  'CM',
  2975,
  'KG',
  1,
);
const threeTon = buildTruckObject(
  `${uuid()}-3-ton`,
  I18n.str('threeTon', '3 Ton'),
  5.6,
  5.6,
  5.6,
  'CM',
  3000,
  'KG',
  3,
);
const sixTon = buildTruckObject(
  `${uuid()}-6-ton`,
  I18n.str('sixTon', '6 Ton'),
  5.6,
  5.6,
  5.6,
  'CM',
  6000,
  'KG',
  6,
);
const sevenTon = buildTruckObject(
  `${uuid()}-7-ton`,
  I18n.str('sevenTon', '7 Ton'),
  5.6,
  5.6,
  5.6,
  'CM',
  7000,
  'KG',
  7,
);
const tenTon = buildTruckObject(
  `${uuid()}-10-ton`,
  I18n.str('tenTon', '10 Ton'),
  5.6,
  5.6,
  5.6,
  'CM',
  10000,
  'KG',
  10,
);
const moreThan25 = buildTruckObject(
  `${uuid()}-25-ton`,
  I18n.str('moreThan25', '> 25 Ton'),
  5.6,
  5.6,
  5.6,
  'CM',
  25000,
  'KG',
  25,
);

export const categories = [
  {
    _id: 'DRY_BOX',
    index: 0,
    icon: require('../../../../assets/img/trucks/truck-side-curtain.svg'),
    subtitle: I18n.str('dryBoxSubTitle', 'From small packages to pallets'),
    name: I18n.str('dryBoxTruck', 'Dry Box'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    childs: [pickup, van, threeTon, sixTon, sevenTon, tenTon, moreThan25],
  },
  {
    _id: 'VAN',
    index: 0,
    icon: require('../../../../assets/img/trucks/van.svg'),
    subtitle: I18n.str('dryBoxSubTitle', 'From small packages to pallets'),
    name: I18n.str('van', 'VAN'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    hide: false,
    childs: [pickup, van, threeTon],
  },
  {
    _id: 'OPEN',
    index: 0,
    icon: require('../../../../assets/img/trucks/truck-open-truck.svg'),
    subtitle: I18n.str('openTruckSubTitle', 'From small packages to pallets'),
    name: I18n.str('openTruck', 'Open Truck'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    childs: [pickup, van, threeTon, sixTon, sevenTon, tenTon],
  },
  {
    _id: 'REEFER',
    index: 0,
    icon: require('../../../../assets/img/trucks/truck-reefer-truck.svg'),
    subtitle: I18n.str('reeferTruckSubTitle', 'From small packages to pallets'),
    name: I18n.str('reeferTruck', 'Reefer Truck'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    childs: [threeTon, sixTon, sevenTon, tenTon, moreThan25],
  },
  {
    _id: 'FLAT_BED',
    index: 0,
    icon: require('../../../../assets/img/trucks/truck-flat-bed.svg'),
    subtitle: I18n.str('flatBedTruckSubTitle', 'From small packages to pallets'),
    name: I18n.str('flatBedTruck', 'Flat Bed'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    childs: [moreThan25],
  },
  {
    _id: 'SIDE_CURTAIN',
    index: 0,
    icon: require('../../../../assets/img/trucks/truck-dry-box.svg'),
    subtitle: I18n.str('sideCurtainTruckSubTitle', 'From small packages to pallets'),
    name: I18n.str('sideCurtainTruck', 'Side Curtain'),
    insurance: {
      url: 'http://placehold.it/32x32',
      maxValue: 34132,
    },
    hideDimensions: true,
    full: true,
    childs: [moreThan25],
  },
];
